export default {
    intro: {
        name: 'Share',
        color: '#00B2E3',
    },

    feel: {
        name: 'Feel',
        color: '#ee1651',
    },

    imagine: {
        name: 'Imagine',
        color: '#ff771a',
    },

    do: {
        name: 'Do',
        color: '#41BC97',
    },

    share: {
        name: 'Share',
        color: '#00B2E3',
    }
}

